import { Injectable } from "@angular/core";
import { LayoutDefinition } from "../../../components/transport-details/transport-details-model";
import { TransportDetailLayout, TransportDetailLayoutColumn, TransportDetailLayoutFieldReference, TransportDetailLayoutRow, TransportDetailLayoutSequence } from "../../configuration/transport.configuration";

@Injectable({
  providedIn: 'root'
})
export class TransportDetailsLayoutConverter {

  public convert(layoutDefinition: LayoutDefinition): TransportDetailLayout {

    console.log('converting layout', layoutDefinition);

    if (!layoutDefinition || layoutDefinition == null) {
      return null;
    }

    const result = new TransportDetailLayout();
    result.propertyId = layoutDefinition.propertyId;

    const sequence = new TransportDetailLayoutSequence();
    result.sequences.push(sequence);

    for (let section of layoutDefinition.sections) {

      const column = new TransportDetailLayoutColumn();
      sequence.columns.push(column);

      for (let field of section.fields) {

        if (field.key == 'register-now') {
          continue;
        }

        const row = new TransportDetailLayoutRow();
        column.rows.push(row);

        const fieldReference = new TransportDetailLayoutFieldReference();
        // fieldReference.data = field.;
        fieldReference.key = this.mapIdentifier(field.key!);
        fieldReference.identifier = field.identifier;
        fieldReference.required = field.required;
        fieldReference.scale = 1;
        fieldReference.width = 100;

        if (fieldReference.key === 'dictionary') {
          fieldReference.dictionaryKey = layoutDefinition.dictionaryBase + '.' + result.propertyId + '.' + fieldReference.identifier;
        }

        row.fields.push(fieldReference);

      }
    }

    return result;
  }

  public mapAttributes(attributes: Array<string>): Array<string> {
    const result = new Array<string>();
    for (const attribute of attributes) {
      result.push(this.mapIdentifier(attribute));
    }
    return result;
  }

  private mapIdentifier(identifier: string): string {
    switch (identifier) {
      case 'driver': return 'driverName';
      case 'co-driver': return 'coDriver';
      case 'numberplate': return 'numberPlate';
      case 'trailer-number-plate': return 'first-lc-trailerNumberPlate';
      case 'swap-trailer-number': return 'first-lc-swapTrailerNumber';
      case 'management-level': return 'managementLevel';
      case 'order-reference': return 'first-lc-orderReference';
      case 'string-1': return 'string1';
      case 'string-2': return 'string2';
      case 'identity-card': return 'identityCard';
      case 'data-protection-rule': return 'dataProtectionRuleId';
      case 'dangerous-goods': return 'dangerousGoods';
      case 'delayed-leave': return 'delayedLeave';
      case 'stays-on-yard-as-vehicle': return 'staysOnYardAsVehicle';
      case 'pickup-truck': return 'pickupTruck';
      case 'planning-type': return 'timeslot';
      case 'trailer-identifier': return 'first-lc-trailerIdentifier';
      case 'messaging-language': return 'messagingLanguage';
      case 'use-global-connect': return 'useGlobalConnect';
      case 'use-sms': return 'useSms';
      case 'vehicle-type': return 'vehicleTypeDictionaryKey';
      case 'loading-type': return 'loadingTypeDictionaryKey';
      case 'identifier': return 'identifyingNumberplate';
      case 'transport-option-marks': return 'transportOptionMarks';
      case 'current-routing-position-hint': return 'current-position-hint';
      case 'current-routing-position-cargo': return 'current-position-cargo';
      case 'current-routing-position-name': return 'current-position-locationName';
      case 'current-routing-position-start': return 'current-position-start';
      case 'entrance-date': return 'entranceDate';
      case 'leaveDate': return 'leaveDate';
      case 'planning-date': return 'planningDate';
      case 'waiting-time': return 'waitingTime';
      case 'processing-time': return 'processingTime';
      case 'current-routing-position-option-values': return 'current-position-optionValues';
      case 'next-routing-position-option-values': return 'next-position-optionValues';
      case 'transport-scope': return 'transportScope';
      case 'visitStatusDict': return 'status';
      case 'currentStation': return 'currentLocationName';
      case 'nextStation': return 'next-position-locationName';
      case 'reference': return 'first-lc-orderReference';
      case 'options': return 'transportOptionMarks';
      case 'cargo': return 'cargoOfRoutingPositions';
      case 'currentPositionStatus': return 'current-position-processingStatusModelStatus';
      case 'currentPositionStart': return 'current-position-start';
      case 'currentPositionStatusStart': return 'current-position-statusStart';
      case 'currentPositionDuration': return 'current-position-duration';
      case 'currentPositionStatusDuration': return 'current-position-statusDuration';
      case 'currentPositionCargo': return 'current-position-cargo';
      case 'currentPositionHint': return 'current-position-hint';
      case 'beginReal': return 'relevantStart';
      case 'currentRoutingPositionOptionValues': return 'current-position-optionValues';
      case 'nextProcessingPositionOptionValues': return 'next-position-optionValues';
      case 'currentPositionIfsStatus1': return 'current-position-ifsStatus1';
      case 'currentPositionIfsStatus2': return 'current-position-ifsStatus2';
      case 'processingTimeCurrentProcessing': return 'processingTimeCurrentProcessing';
      case 'phone': return 'phone';
      case 'cabotageRelevant': return 'cabotageRelevant';
    }

    let unchanged = [
      'processingTime', 'waitingTime', 'planningDate', 'carrier', 'supplier', 'messagingResources', 'start', 'registrationCode', 'name', 'internal', 'transportOptionAmounts', 'transportOptionParameterValues'
    ];

    return identifier;
  }

}
